/**
 * Ifc Link Geometry
 *
 * Draws the real mesh of a linked .ifc model (Link IFC / Link Coordination
 * Model). The vertex data lives in the IndexedDB asset store baked at link
 * time (services/ifc/IfcLinkService); this component resolves it through
 * the shared useIfcAsset hook and walks the parts as individual meshes at
 * the wrapper element origin. Selection overlays ink edges like every
 * other category renderer.
 */

import * as THREE from 'three';
import { useIfcAsset } from './StaticMeshFamilyRenderer';
import { InkEdges } from './InkEdges';
import { BACKFACE_DEFINES } from './backfaceTint';

export function IfcLinkGeometry({ assetId, isSelected }: { assetId: string; isSelected: boolean }) {
    const resolved = useIfcAsset(assetId);
    if (!resolved || resolved.geometries.length === 0) return null;

    return (
        <group>
            {resolved.geometries.map((geo, i) => (
                <mesh key={i} geometry={geo}>
                    <meshStandardMaterial
                        color={resolved.colors[i] ? new THREE.Color().setRGB(resolved.colors[i][0], resolved.colors[i][1], resolved.colors[i][2]) : '#9aa0a6'}
                        metalness={0}
                        roughness={0.85}
                        side={THREE.DoubleSide}
                        defines={BACKFACE_DEFINES}
                    />
                    {isSelected && <InkEdges isSelected={isSelected} />}
                </mesh>
            ))}
        </group>
    );
}
